var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:[
		{ 'nav-open': _vm.$sidebar.showSidebar },
		{ noSidebar: !_vm.hasSidebar },
		{ rtl: _vm.$route.meta.rtlActive }
	]},[(_vm.hasSidebar)?[(_vm.isLoggedIn)?_c('DashSideNav'):_c('SignUpNavBar')]:_vm._e(),_c('div',{staticClass:"main-panel box_bg_color"},[_c('TopNavbar'),_c('div',{staticClass:"content",on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),_c('ContentFooter')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }